import React, { useState } from 'react';
import './CaseStudy.css';

const CaseStudy = () => {
  const [activeFilter, setActiveFilter] = useState('TOUS');

  const caseStudies = [
    {
      category: 'Industrie',
      title: 'Fabricant de solutions d\'automatisation industrielle',
      challenge: 'Cette PME industrielle dispose d\'une expertise technique exceptionnelle mais peine à atteindre les décideurs dans les grands groupes industriels.',
      solution: [
        'Optimisation des profils LinkedIn des experts techniques',
        'Séquence de messages personnalisés sur LinkedIn',
        'Création de contenus démonstratifs sur les problématiques techniques',
        'Webinaires ciblés pour responsables de production'
      ],
      results: [
        '+127% de taux de réponse aux sollicitations',
        '14 rendez-vous qualifiés générés en 3 mois',
        '4 nouveaux clients signés',
        'ROI de 380% sur l\'investissement Prosperian'
      ],
      testimonial: {
        quote: "Prosperian a transformé notre approche commerciale en capitalisant sur notre expertise technique. Nous parlons désormais le langage de nos clients et accédons enfin aux bons décideurs.",
        author: "Marc Dubois",
        position: "Directeur Commercial"
      },
      tags: ['LinkedIn', 'Webinaires', 'Content Marketing', 'B2B']
    },
    {
      category: 'Finance',
      title: 'Cabinet de conseil en fusion-acquisition',
      challenge: 'Ce cabinet spécialisé dans les opérations de M&A pour PME cherchait à identifier des dirigeants envisageant une cession dans les 24 mois.',
      solution: [
        'Campagne d\'emailing ultra-ciblée vers dirigeants de PME',
        'Webinaires confidentiels sur la préparation à la cession',
        'Programme de nurturing sur 12 mois',
        'LinkedIn Sales Navigator pour la détection de signaux d\'intention'
      ],
      results: [
        '4 200 dirigeants ciblés',
        '26 participants aux webinaires',
        '8 nouveaux mandats de cession',
        'Valeur générée estimée à 1,2M€ de commissions'
      ],
      testimonial: {
        quote: "L'approche Prosperian nous a permis de détecter des projets de cession très en amont, nous donnant un avantage concurrentiel majeur dans notre secteur.",
        author: "Sophie Martin",
        position: "Associée Fondatrice"
      },
      tags: ['Email Marketing', 'Webinaires', 'Finance', 'M&A']
    },
    {
      category: 'Tech & SaaS',
      title: 'Éditeur de logiciel SaaS pour le secteur RH',
      challenge: 'Acteur innovant dans un marché saturé, cette scale-up peinait à se différencier et à obtenir des démonstrations auprès des DRH de grandes entreprises.',
      solution: [
        'Refonte complète du discours commercial',
        'Création d\'une séquence d\'acquisition multi-canal',
        'Production de cas d\'usage sectoriels',
        'Landing pages personnalisées par cible'
      ],
      results: [
        'Taux de conversion des landing pages multiplié par 3,5',
        '42 démonstrations produit générées en 2 mois',
        'Coût d\'acquisition réduit de 62%',
        'Accélération du cycle de vente de 40%'
      ],
      testimonial: {
        quote: "Prosperian nous a aidés à clarifier notre positionnement et à construire une machine d'acquisition qui convertit. Notre équipe commerciale a maintenant plus de démonstrations qu'elle ne peut en traiter!",
        author: "Alexandre Chen",
        position: "CEO & Co-fondateur"
      },
      tags: ['SaaS', 'Multi-canal', 'Landing Pages', 'Conversion Rate']
    },
    {
      category: 'Services Pro',
      title: 'Cabinet de formation professionnelle',
      challenge: 'Ce spécialiste de la formation management devait diversifier sa clientèle, trop concentrée sur quelques grands comptes, et atteindre les responsables formation d\'ETI.',
      solution: [
        'Campagne LinkedIn ciblant les responsables formation',
        'Production de contenus éducatifs sur les enjeux de formation',
        'Organisation de tables rondes virtuelles',
        'Automatisation du suivi des prospects'
      ],
      results: [
        '18 nouveaux comptes ETI ouverts en 6 mois',
        'Élargissement du portefeuille client de 37%',
        'Augmentation du panier moyen de 22%',
        'Réduction de la dépendance aux grands comptes'
      ],
      testimonial: {
        quote: "En seulement 6 mois, Prosperian nous a permis de diversifier significativement notre portefeuille clients et de sécuriser notre croissance.",
        author: "Nathalie Leroy",
        position: "Directrice du Développement"
      },
      tags: ['Formation', 'LinkedIn', 'ETI', 'Diversification']
    },
    {
      category: 'Logistique',
      title: 'Prestataire logistique spécialisé',
      challenge: 'Cet acteur de niche dans la logistique de produits sensibles avait besoin d\'accroître sa notoriété et d\'atteindre les décideurs dans les secteurs pharmaceutique et cosmétique.',
      solution: [
        'Programme d\'inbound marketing sectoriel',
        'Webinaires techniques sur la chaîne du froid',
        'Campagne LinkedIn avec contenus experts',
        'Participation amplifiée à des événements sectoriels'
      ],
      results: [
        'Augmentation de 87% du trafic qualifié sur le site',
        '34 leads entrants générés',
        '8 nouveaux contrats signés',
        'Notoriété renforcée sur le secteur pharmaceutique'
      ],
      testimonial: {
        quote: "Prosperian a compris notre expertise de niche et l'a transformée en véritable avantage commercial. Nous sommes désormais reconnus comme experts dans notre domaine.",
        author: "Thomas Petit",
        position: "Directeur Général"
      },
      tags: ['Logistique', 'Inbound Marketing', 'Webinaires', 'LinkedIn']
    },
    {
      category: 'Tech & SaaS',
      title: 'Agence de cybersécurité B2B',
      challenge: 'Cette agence spécialisée en audit et conseil cybersécurité cherchait à convertir son expertise technique en arguments commerciaux pour convaincre les DSI et RSSI.',
      solution: [
        'Mise en place d\'une stratégie d\'Account-Based Marketing',
        'Création de scénarios d\'attaque personnalisés par cible',
        'Séquence LinkedIn pour les RSSI et DSI',
        'Événements de démonstration en petit comité'
      ],
      results: [
        '65% de taux d\'engagement sur les communications',
        '12 grands comptes convertis',
        'Ticket moyen augmenté de 45%',
        'Pipeline commercial sécurisé sur 12 mois'
      ],
      testimonial: {
        quote: "La méthodologie Prosperian nous a permis de traduire notre expertise technique en langage business, et de créer une véritable connexion avec les décideurs.",
        author: "Julien Moreau",
        position: "Responsable Business Development"
      },
      tags: ['Cybersécurité', 'ABM', 'LinkedIn', 'Event Marketing']
    }
  ];

  const filters = ['TOUS', 'INDUSTRIE', 'TECH & SAAS', 'FINANCE', 'SERVICES PRO', 'LOGISTIQUE'];

  const filteredCases = activeFilter === 'TOUS' 
    ? caseStudies 
    : caseStudies.filter(study => study.category.toUpperCase() === activeFilter);

  return (
    <section className="case-study-section">
      <div className="case-study-container">
        <div className="case-study-header">
          <h1 className="case-study-title">Études de cas</h1>
          <p className="case-study-intro">
            Découvrez comment Prosperian a aidé des entreprises comme la vôtre à transformer leur approche de prospection B2B et à générer des résultats concrets.
          </p>
        </div>

        <div className="case-study-filters">
          {filters.map(filter => (
            <button
              key={filter}
              className={`filter-button ${activeFilter === filter ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>

        <div className="case-studies-grid">
          {filteredCases.map((study, index) => (
            <div key={index} className="case-study-card">
              <div className="case-study-content">
                <span className="case-category">{study.category}</span>
                <h2 className="case-title">{study.title}</h2>
                <p className="case-challenge">{study.challenge}</p>
                
                <div className="case-section">
                  <h3>Notre solution:</h3>
                  <ul>
                    {study.solution.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                <div className="case-section">
                  <h3>Résultats:</h3>
                  <ul>
                    {study.results.map((result, i) => (
                      <li key={i}>{result}</li>
                    ))}
                  </ul>
                </div>

                <div className="case-testimonial">
                  <blockquote>
                    {study.testimonial.quote}
                  </blockquote>
                  <cite>
                    {study.testimonial.author}, {study.testimonial.position}
                  </cite>
                </div>

                <div className="case-tags">
                  {study.tags.map((tag, i) => (
                    <span key={i} className="tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="case-study-cta">
        <div className="case-study-container">
          <h2 className="cta-title">DÉCOUVREZ VOTRE POTENTIEL DE CROISSANCE</h2>
          <p className="cta-description">
            Votre Prosperian Score™ peut être recalculé tous les 3 mois. C'est la meilleure façon de mesurer l'impact de votre transformation commerciale, en comparant vos scores dans le temps.
          </p>
          <div className="progress-stat">
            <p className="progress-stat-text">
              Entreprises accompagnées par Prosperian : <span className="progress-highlight">+14 pts en moyenne après 12 mois</span>
            </p>
          </div>
          <button className="cta-button">OBTENIR MON SCORE</button>
        </div>
      </div>

      <div className="case-study-cta secondary">
        <div className="case-study-container">
          <h2 className="cta-title">Prêt à accélérer votre croissance ?</h2>
          <p className="cta-description">
            Découvrez comment notre méthodologie peut s'adapter à vos enjeux spécifiques.
          </p>
          <div className="cta-buttons">
            <button className="cta-button">Demander une démo</button>
            <button className="cta-button secondary">Tester mon éligibilité</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudy; 